export const lineHeight1 = 1.4
export const lineHeight2 = 1.6
export const lineHeight3 = 1.7
